import React from "react";
import { T } from "./Translate";
import { Container, Box, Link } from "@mui/material";
import BottomToolbar from "./BottomToolbar";
import PageHeader from "./PageHeader";
import { pageContentSx } from "../pageLayout";

const Terms = () => {
  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <PageHeader title={<T>Términos y Condiciones</T>} />
      <Container sx={{ mt: "16px", mb: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Box>
            <h1><T>Términos y Condiciones de Notiline</T></h1>

            <p><T>¡Bienvenido a Notiline!</T></p>

            <p>
              <T>Estos Términos y Condiciones rigen el uso de Notiline, la app de Dapur
              Tecnología para publicar y descubrir ofertas, eventos, tiendas, vehículos y
              propiedades/viajes, y para hacer y recibir pedidos de comida y súper. Al crear una cuenta o usar la app, aceptás estos términos.
              Si no estás de acuerdo, no uses Notiline.</T>
            </p>

            <h2><T>1. Qué es Notiline</T></h2>
            <p>
              <T>Notiline es un marketplace donde los usuarios pueden publicar y consultar
              ofertas y cupones de descuento, eventos, tiendas, vehículos y
              propiedades/viajes, seguir tiendas, chatear con otros usuarios, guardar
              publicaciones, comprar entradas, hacer pedidos a locales y suscribirse a planes pagos. Notiline conecta
              a compradores y vendedores/organizadores, pero no es parte de las
              transacciones ni de los productos y servicios que ofrecen los usuarios.</T>
            </p>

            <h2><T>2. Tu cuenta</T></h2>
            <ul>
              <li>
                <T>Para usar Notiline necesitás crear una cuenta con un email válido y datos
                reales (nombre, teléfono, localidad).</T>
              </li>
              <li>
                <T>Sos responsable de mantener segura tu contraseña y de toda la actividad
                que ocurra en tu cuenta. Te recomendamos activar la verificación en dos
                pasos desde Ajustes.</T>
              </li>
              <li>
                <T>Debés tener al menos la edad mínima legal en tu país para aceptar estos
                términos; Notiline no está dirigido a menores de 13 años.</T>
              </li>
              <li>
                <T>Podés cerrar tu cuenta cuando quieras desde Ajustes o escribiéndonos a
                support@notiline.com.</T>
              </li>
            </ul>

            <h2><T>3. Contenido que publicás</T></h2>
            <p>
              <T>Al publicar una oferta, evento, tienda, local, producto, auto, propiedad, comentario o
              cualquier otro contenido, declarás que:</T>
            </p>
            <ul>
              <li><T>Tenés derecho a publicarlo y toda la información que incluye es veraz.</T></li>
              <li><T>No infringe derechos de propiedad intelectual, marcas ni derechos de terceros.</T></li>
              <li><T>No contiene material difamatorio, engañoso, ilegal, obsceno o discriminatorio.</T></li>
              <li><T>No se usa para promocionar actividades ilegales, spam ni fraude.</T></li>
            </ul>
            <p>
              <T>Notiline puede revisar, ocultar o eliminar cualquier publicación o comentario
              que incumpla estos términos, y suspender cuentas que lo hagan de forma
              reiterada. No somos responsables por el contenido publicado por los usuarios,
              aunque nos reservamos el derecho de moderarlo.</T>
            </p>

            <h2><T>4. Ofertas, cupones, compras y pedidos</T></h2>
            <p>
              <T>Las ofertas y cupones que ves en Notiline son publicados por tiendas y
              usuarios: los precios, el stock y las condiciones de cada oferta son
              responsabilidad de quien la publica. Al canjear un cupón (por ejemplo,
              escaneando un código QR) o comprar una entrada a un evento, estás contratando
              directamente con esa tienda u organizador, no con Notiline.</T>
            </p>

            <h3><T>Pedidos de comida y súper</T></h3>
            <p>
              <T>En la sección Pedidos podés pedirles productos a restaurantes, súper y otros
              locales. Al hacer un pedido contratás directamente con el local, no con Notiline.</T>
            </p>
            <ul>
              <li><T>El local es responsable de sus precios, stock, horarios, preparación y envío, de la calidad y seguridad de sus productos, de la información que publica sobre ellos, incluidos los alérgenos, y de los permisos que exija su actividad.</T></li>
              <li><T>Los pedidos se pagan en efectivo o por transferencia directamente al local. Notiline no procesa ni recibe esos pagos.</T></li>
              <li><T>Podés cancelar un pedido desde la app mientras el local no lo haya aceptado. El local puede rechazar un pedido.</T></li>
              <li><T>La entrega se confirma con un código de 4 dígitos. Compartilo recién cuando recibas el pedido, porque con ese código se marca como entregado.</T></li>
              <li><T>Tenés que dar una dirección y un teléfono reales para que el local pueda entregar el pedido.</T></li>
              <li><T>Para tener un local necesitás una suscripción activa. Sin ella, el local deja de aparecer en Pedidos y no recibe pedidos nuevos, y debés terminar los que ya tengas en curso. El local debe usar los datos de sus clientes solo para preparar y entregar los pedidos, y contar con el consentimiento del repartidor para compartir su ubicación.</T></li>
              <li><T>Los reclamos y devoluciones de un pedido se rigen por nuestra Política de Reembolsos, disponible en Ajustes.</T></li>
            </ul>

            <h2><T>5. Suscripciones y pagos con PayPal</T></h2>
            <p>
              <T>Notiline ofrece planes de suscripción pagos y permite comprar entradas a
              eventos. Todos estos pagos se procesan a través de PayPal. Al suscribirte o
              comprar, aceptás además lo siguiente:</T>
            </p>

            <h3><T>Suscripción y renovación</T></h3>
            <ul>
              <li><T>El cargo inicial se realiza al momento de suscribirte, y los siguientes en cada renovación del período.</T></li>
              <li><T>La suscripción se renueva automáticamente hasta que la canceles.</T></li>
              <li><T>Los precios pueden cambiar con un aviso previo de al menos 30 días.</T></li>
            </ul>

            <h3><T>Cancelación y fallos de pago</T></h3>
            <ul>
              <li><T>Podés cancelar en cualquier momento desde tu cuenta de PayPal o desde la sección Suscripción de Notiline; la cancelación aplica al final del período ya pagado.</T></li>
              <li><T>Si un pago falla, lo reintentamos durante 3 días; después de tres intentos fallidos, la cuenta se suspende hasta actualizar el método de pago.</T></li>
            </ul>

            <h3><T>Cambios de plan y reembolsos</T></h3>
            <ul>
              <li><T>Podés cambiar de plan cuando quieras: las mejoras se aplican de inmediato y las bajas de plan al siguiente período.</T></li>
              <li><T>Los reembolsos se rigen por nuestra Política de Reembolsos, disponible en Ajustes.</T></li>
            </ul>

            <h2><T>6. Notificaciones y ubicación</T></h2>
            <p>
              <T>Notiline puede enviarte notificaciones push y usar tu ubicación para
              mostrarte contenido relevante cerca tuyo. Podés desactivar las notificaciones
              o el acceso a tu ubicación desde la configuración de tu dispositivo, aunque
              esto puede limitar algunas funciones de la app.</T>
            </p>

            <h2><T>7. Conducta prohibida</T></h2>
            <p><T>Al usar Notiline, no podés:</T></p>
            <ul>
              <li><T>Suplantar a otra persona o crear cuentas falsas.</T></li>
              <li><T>Acosar, amenazar o discriminar a otros usuarios.</T></li>
              <li><T>Intentar vulnerar la seguridad de la app o acceder a cuentas ajenas.</T></li>
              <li><T>Usar bots, scraping u otros medios automatizados no autorizados.</T></li>
              <li><T>Revender, copiar o redistribuir el contenido o el código de Notiline sin autorización.</T></li>
            </ul>

            <h2><T>8. Propiedad intelectual</T></h2>
            <p>
              <T>Notiline y su marca, logo y diseño son propiedad de Dapur Tecnología. El
              contenido que vos publicás sigue siendo tuyo, pero nos das una licencia no
              exclusiva para mostrarlo dentro de la app con el fin de operar el servicio
              (por ejemplo, en el feed, en búsquedas o en notificaciones).</T>
            </p>

            <h2><T>9. Suspensión y cierre de cuenta</T></h2>
            <p>
              <T>Podemos suspender o cerrar tu cuenta si incumplís estos Términos, si
              detectamos actividad fraudulenta, o por requerimiento legal. También podés
              cerrar tu cuenta vos mismo cuando quieras.</T>
            </p>

            <h2><T>10. Límite de responsabilidad</T></h2>
            <p>
              <T>Notiline se ofrece "tal cual", sin garantizar que esté siempre disponible o
              libre de errores. En la medida permitida por la ley, no somos responsables por
              transacciones, productos o servicios entre usuarios, ni por daños indirectos
              derivados del uso de la app. Nada en estos Términos limita responsabilidades
              que no puedan excluirse por ley, como las relacionadas con fraude.</T>
            </p>

            <h2><T>11. Cambios a estos Términos</T></h2>
            <p>
              <T>Podemos actualizar estos Términos y Condiciones para reflejar cambios en la
              app o en la normativa aplicable. Si hacemos cambios importantes, te avisaremos
              dentro de la app; si seguís usando Notiline después de eso, aceptás los nuevos
              términos.</T>
            </p>

            <h2><T>12. Contacto</T></h2>
            <p>
              <T>Ante cualquier consulta sobre estos Términos y Condiciones, escribinos a</T>{" "}
              <Link href="mailto:support@notiline.com">support@notiline.com</Link>.
            </p>
          </Box>
        </Container>
      </Container>
      <BottomToolbar />
    </Container>
  );
};

export default Terms;
